import { render, staticRenderFns } from "./Levenswegbuttonnolink.vue?vue&type=template&id=02787141&"
import script from "./Levenswegbuttonnolink.vue?vue&type=script&lang=js&"
export * from "./Levenswegbuttonnolink.vue?vue&type=script&lang=js&"
import style0 from "./Levenswegbuttonnolink.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports